import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { login, logout } from '../store/auth/auth.actions';
import { HttpClient } from '@angular/common/http';
import { jwtDecode, JwtPayload } from 'jwt-decode';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private apiUrl = `${environment.apiUrl}`;
  private url: string = this.apiUrl + 'login';

  private _user: any;

  constructor(
    private authStore: Store<{authRdc: any}>,
    private http: HttpClient) {
    
    this.authStore.select('authRdc').subscribe(state => {
      this._user = state;
    })
  }

  loginUser({ username, password }: any): Observable<any> {
    return this.http.post<any>(this.url, { username, password });
  }

  set user(user: any) {
    sessionStorage.setItem('login', JSON.stringify(user));
  }

  get user() {
    return this._user;
  }

  set token(token: string) {
    sessionStorage.setItem('token', token);
  }

  get token() {
    return sessionStorage.getItem('token')!;
  }

  getPayload(token: string) {
    if (token != null) {
      //return JSON.parse(atob(token.split(".")[1]));
      return jwtDecode(token) as IJwtPayload;
    }
    return null;
  }

  isAdmin() {
    return this.user.isAdmin;
  }

  isSuperAdmin() {
    return this.user.isSuperAdmin;
  }

  isRol(rolFind: string) {
    return this.user.groups.includes(rolFind);
  }

  authenticated() {
    return this.user.isAuth;
  }

  getCompanyId() {
    return this._user.user.companyId;
  }

  logout() {
    this.authStore.dispatch(logout());
    sessionStorage.removeItem('login');
    sessionStorage.removeItem('token');
  }

}

interface IJwtPayload extends JwtPayload  {
  isAdmin: boolean;
  isSuperAdmin: boolean;
  groups: [];
  groupsDescription: [];
  companyId: string;
  companyName: string;
  full_name: string;
}